module.exports = __webpack_public_path__ + "static/media/bbq-chicken.3fb2399d.jpg";